import { Link, Outlet, createRootRoute } from '@tanstack/react-router';

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b border-border bg-bg/80 backdrop-blur sticky top-0 z-40">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <Link to="/" className="font-display text-lg font-semibold tracking-tight text-text">
            pozyskaj<span className="text-accent">pacjenta</span>.pl
          </Link>
          <nav className="flex items-center gap-1 text-sm">
            <Link
              to="/"
              className="rounded-full px-3 py-1.5 text-text-muted hover:bg-surface hover:text-text"
              activeProps={{ className: 'text-text' }}
            >
              Strona główna
            </Link>
            <Link
              to="/cennik"
              className="rounded-full px-3 py-1.5 text-text-muted hover:bg-surface hover:text-text"
              activeProps={{ className: 'text-text' }}
            >
              Cennik
            </Link>
            <a
              href="https://app.pozyskajpacjenta.pl"
              className="rounded-full px-3 py-1.5 text-text-muted hover:bg-surface hover:text-text"
            >
              Logowanie
            </a>
            <Link
              to="/start"
              className="ml-3 rounded-full bg-text px-4 py-1.5 text-sm font-medium text-bg hover:bg-text/90"
            >
              Załóż konto
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="mt-24 border-t border-border bg-surface/60">
        <div className="mx-auto grid max-w-6xl gap-8 px-6 py-12 md:grid-cols-4">
          <div>
            <p className="font-display text-base font-semibold text-text">
              pozyskaj<span className="text-accent">pacjenta</span>.pl
            </p>
            <p className="mt-2 text-xs text-text-muted">
              Strona, kalendarz i SEO dla kliniki w jednym pakiecie. Bez prowizji
              od wizyt. Bez ukrytych opłat.
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-text-subtle">
              Produkt
            </p>
            <ul className="mt-3 space-y-2 text-sm text-text-muted">
              <li><Link to="/cennik" className="hover:text-text">Cennik</Link></li>
              <li><Link to="/start" className="hover:text-text">Załóż konto</Link></li>
              <li><a href="https://app.pozyskajpacjenta.pl" className="hover:text-text">Logowanie</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-text-subtle">
              Dla kogo
            </p>
            <ul className="mt-3 space-y-2 text-sm text-text-muted">
              <li>Kliniki weterynaryjne</li>
              <li>Stomatologia</li>
              <li>Specjalistyczne gabinety</li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-text-subtle">
              Kontakt
            </p>
            <ul className="mt-3 space-y-2 text-sm text-text-muted">
              <li>kontakt@pozyskajpacjenta.pl</li>
              <li>+48 22 100 80 50</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-border">
          <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-2 px-6 py-4 text-xs text-text-subtle">
            <span>© 2026 H2M sp. z o.o. — pozyskajpacjenta.pl</span>
            <span>
              <a href="/polityka-prywatnosci" className="hover:text-text">
                Polityka prywatności
              </a>{' '}
              ·{' '}
              <a href="/regulamin" className="hover:text-text">
                Regulamin
              </a>
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}
